import type { BrandThemeIcon } from '@jotta/types/Brand'
import type { Locale } from './locale'

export interface LanguageToolbarItemConfig {
  value: Locale
  title: string
  flag: string
}

export const languageToolbar: LanguageToolbarItemConfig[] = [
  {
    value: 'ca',
    title: 'Català',
    flag: '🇪🇸',
  },
  {
    value: 'da',
    title: 'Dansk',
    flag: '🇩🇰',
  },
  {
    value: 'de',
    title: 'Deutsch',
    flag: '🇩🇪',
  },
  {
    value: 'en',
    title: 'English',
    flag: '🇬🇧',
  },
  {
    value: 'es',
    title: 'Español',
    flag: '🇪🇸',
  },
  {
    value: 'fr',
    title: 'Français',
    flag: '🇫🇷',
  },
  {
    value: 'nl',
    title: 'Nederlands',
    flag: '🇳🇱',
  },
  {
    value: 'nb',
    title: 'Norsk',
    flag: '🇳🇴',
  },
  {
    value: 'pl',
    title: 'Polski',
    flag: '🇵🇱',
  },
  {
    value: 'pt',
    title: 'Português',
    flag: '🇵🇹',
  },
  {
    value: 'fi',
    title: 'Suomi',
    flag: '🇫🇮',
  },
  {
    value: 'sv',
    title: 'Svenska',
    flag: '🇸🇪',
  },
]
